import MaterialsBin from './MaterialsBin'

export default MaterialsBin
